import React, { useEffect, useState } from 'react';
import { subscribeLoading } from '../utils/loadingBar';

/**
 * Persistent top-of-viewport progress bar. Reacts to in-flight API requests
 * (see Services/services.js interceptors), so it lights up both when
 * switching pages (data fetched on mount) and during in-page loads like
 * search, sort, and pagination — with no per-page wiring required.
 */
export default function NavigationProgressBar() {
  const [active, setActive] = useState(false);

  useEffect(() => subscribeLoading(setActive), []);

  return (
    <div
      className={`top-progress-bar${active ? ' top-progress-bar--active' : ''}`}
      role="progressbar"
      aria-hidden={!active}
      aria-label="Loading"
    />
  );
}
